import { Button, Flex, Table, Tag, Form, Select, Input, Col, Row, Avatar } from "antd";
import React, { useState } from "react";
import Title from "antd/es/typography/Title";
import { useEffect } from "react";
import { colors } from "../../../../../constants/colors";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Spinner from "../../../../common/spinner/Spinner";
import { appConstConfig } from "../../../../../constants/config/appConstConfig";
import {
  getServiceProviderPackagesAction,
  getServiceProviderServicesAction,
  updateOrganizationServicesStatusAction,
} from "../../../../../redux/services/service-providers/serviceProvidersServices";
import { dateObjToDispViewDate } from "../../../../../utils/utils";
import { ArrowLeftOutlined, SearchOutlined } from "@ant-design/icons";
import useDebounce from "../../../../../hooks/useDebounce";
import { UserOutlined } from "@ant-design/icons";

const ServiceProviderDetailsPackages = () => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* For navigating between pages */
  const navigate = useNavigate();
  /* For navigating between pages */

  /* form dependencies */
  const [form] = Form.useForm();
  /* form dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  const [selectListLoader, setSelectListLoader] = useState(false);
  /* loading dependencies */

  /* id dependencies */
  const { serviceProviderPackages } = useSelector(
    (state) => state.serviceProviders
  );

  const {
    selectedServiceProvider: { selectedServiceProviderId, navigateBack },
  } = useSelector((state) => state.serviceProviders);
  /* id dependencies */


  /* table dependencies */
  const [columns, setColumns] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [pagination, setPagination] = useState({
    pageNo: appConstConfig.DEFAULT_TABLE_PAGE_NUMBER,
    pageSize: appConstConfig.DEFAULT_TABLE_PAGE_SIZE,
  });
  const paginationObj = {
    total: serviceProviderPackages?.total,
    current: pagination?.pageNo,
    pageSize: pagination?.pageSize,
    onChange: (pageNo, pageSize) => setPagination({ pageNo, pageSize }),
    pageSizeOptions: appConstConfig.DEFAULT_PAGE_SIZE_OPTIONS_ARR,
    showSizeChanger: true,
  };
  const { debouncedValue: debouncedSearchValue, debounceLoading } = useDebounce(
    searchValue,
    500
  );
  /* table dependencies */

  useEffect(() => {
    handleGetTableData();
  }, [pagination, debouncedSearchValue]);

  const handleGetTableData = () => {
    /* initial dependencies - Edit */
    if (
      selectedServiceProviderId &&
      selectedServiceProviderId !== "" &&
      selectedServiceProviderId !== null &&
      selectedServiceProviderId !== undefined
    ) {
      const dataToBeSent = {
        page: pagination?.pageNo,
        limit: pagination?.pageSize,
        selectedOrganizationId: selectedServiceProviderId,
        search:debouncedSearchValue
      };
      setLoading(true);
      dispatch(getServiceProviderPackagesAction(dataToBeSent, setLoading));
    }
    /* initial dependencies - Edit */
  };

  /* on status changed */
  const onStatusChanged = (id, value, record) => {
    const dataToBeSent = {};
    dataToBeSent.selectedOrganizationId = record?._id;
    dataToBeSent["is_active"] = value?.value === "active" ? true : false;

    dispatch(
      updateOrganizationServicesStatusAction(dataToBeSent, setLoading)
    ).then(() => {
      handleGetTableData();
    });
  };
  /* on status changed */

  /* initial dependencies rendering */
  useEffect(() => {
    /* table column config */
    const tempTableColumns = [
      {
        title: t("Modules.Packages.packageNameLabel"),
        key: "packageName",
        render: (_, { banner }) => {
          return (
            <Flex gap="1rem" align="center">
              <Avatar src={banner} key={banner} icon={<UserOutlined />} />
              {`${_.title}`}
            </Flex>
          );
        },
      },
      {
        title: t("Modules.Packages.startDate"),
        dataIndex: "packageStartDate",
        key: "packageStartDate",
        render: (_, record) => (
          <p>{dateObjToDispViewDate(record?.packageStartDate, "ddmmyyyy")}</p>
        ),
      },
      {
        title: t("Modules.Packages.endDate"),
        dataIndex: "packageEndDate",
        key: "packageEndDate",
        render: (_, record) => (
          <p>{dateObjToDispViewDate(record?.packageEndDate, "ddmmyyyy")}</p>
        ),
      },
      {
        title: t("Modules.Packages.thSponsored"),
        key: "top_listing_enabled",
        dataIndex: "top_listing_enabled",
        render: (_, record) => (
          <>
            <Tag
              bordered={false}
              style={{
                background: record?.top_listing_enabled
                  ? colors.lightTeal
                  : colors.lightPinkishRed,
                color: record?.top_listing_enabled
                  ? colors.darkTeal
                  : colors.darkMaroon,
              }}
            >
              {record?.top_listing_enabled
                ? t("Modules.Packages.thSponsored")
                : t("Modules.Packages.regular")}
            </Tag>
          </>
        ),
      }
    ];
    /* table column config */
    setColumns(tempTableColumns);
  }, []);
  /* initial dependencies rendering */

  return (
    <div className="servicesListContainer">
      <Flex vertical gap="2rem">
        <Flex gap="1rem" align="center">
          <Button
            type="default"
            shape="circle"
            size="small"
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate(navigateBack)}
          />
          <Input
            size="large"
            suffix={<SearchOutlined />}
            placeholder={t("Modules.customer.search")}
            onChange={(event) => setSearchValue(event.target.value)}
            style={{ width: "370px" }}
          />
        </Flex>
        {loading || debounceLoading ? (
          <Spinner />
        ) : (
          <Table
            dataSource={serviceProviderPackages?.data}
            columns={columns}
            pagination={paginationObj}
          />
        )}
      </Flex>
    </div>
  );
};

export default ServiceProviderDetailsPackages;
